import React, { useEffect, useState } from 'react'
import { Box, Button, Heading, Text } from 'rebass/styled-components'
import styled from 'styled-components'
import { Link } from 'gatsby'
import renderHTML from 'react-render-html'
import MediaRender from '../components/general/MediaRender'
import SwiperFilmStrip from '../components/swiper/FilmStrip'
import FeaturedPublication from './FeaturedPublication'

const HorizontalRuler = styled(Box)`
    background-color: transparent;
    border-color: ${(props) => props.theme.colors.aquaDark};
    border-style: solid;
    border-width: 1px 0 3px 0;
    display: block;
    height: 8px;
    margin-top: 0;
    margin-right: 0;
    margin-bottom: 4px;
    margin-left: 0;
    padding: 0;
`

const NarrativeContent = styled(Box)`
    a {
        background-color: transparent;
        background-image: linear-gradient(to right, #77b7be 0, #77b7be 100%);
        background-position: 0 100%;
        background-repeat: no-repeat;
        background-size: 0 2px;
        border-color: ${(props) => props.theme.colors.black};
        border-style: solid;
        border-width: 0 0 2px 0;
        color: ${(props) => props.theme.colors.black};
        cursor: pointer;
        display: inline;
        padding-bottom: 1px;
        padding-top: 1px;
        will-change: background-size;
        text-decoration: none;

        &:hover {
            background-size: 100% 2px;
            border-color: transparent;
            padding-bottom: 3px;
            transition-duration: 400ms;
            transition-property: background-size;
            transition-timing-function: cubic-bezier(0.2, 0.75, 0.5, 1);
        }
    }
`

const Badge = styled(Box)`
    align-items: center;
    border-radius: 100%;
    color: ${(props) => props.theme.colors.aquaLight};
    display: flex;
    font-family: ${(props) => props.theme.fonts.heading};
    font-size: 28px;
    height: 82px;
    justify-content: center;
    line-height: 22px;
    position: absolute;
    right: 6px;
    text-align: center;
    top: -43px;
    width: 82px;
    z-index: 1;
    @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
        font-size: 18px;
        height: 64px;
        line-height: 18px;
        top: -33px;
        width: 64px;
    }
`

const FeaturedMobile = ({ firstModule, options, data }) => {
    let content = null
    const badge = data?.categories?.includes('sold') ? (
        <Badge bg='aquaDark'>Sold</Badge>
    ) : null
    const [media, updateMedia] = useState({ el: false, enlarged: false })
    // eslint-disable-next-line no-unused-vars
    const [carousel, updateCarousel] = useState(
        options.carouselSource === 'gallery'
            ? data.media.gallery?.images
            : options.media.set
    )

    useEffect(() => {
        if (options.media.set && options.media.set.length) {
            const update = { ...media }
            update.el = (
                <MediaRender
                    file={options.media.set[0]}
                    alt={options.title}
                />
            )
            update.enlarged = options.enlarged || false
            updateMedia(update)
        }
        if ((!options.media || options.media === '') && options.video) {
            const update = { ...media }
            update.el = <MediaRender file={options.video} />
            update.enlarged = options.enlarged || false
            updateMedia(update)
        }
    }, [options])

    const switchImage = (slide) => {
        const update = { ...media }
        update.el = (
            <MediaRender
                file={slide}
                alt={options.heading}
            />
        )
        update.enlarged = true
        updateMedia(update)
    }

    switch (options.type) {
        case 'publication':
            content = <FeaturedPublication options={options} />
            break
        default:
            content = (
                <Box>
                    {options.showBorderRipple ? (
                        <>
                            {' '}
                            <HorizontalRuler as='hr' />{' '}
                        </>
                    ) : null}
                    <Box
                        bg={options.backgroundColor}
                        pt={firstModule ? 'xxl' : 'md'}
                        pb={options.showHeadingSection ? 'lg' : '0'}
                    >
                        <Box variant='container'>
                            {options.showHeadingSection ? (
                                <>
                                    <Box
                                        pt={firstModule ? 'md' : '0'}
                                        px='sm'
                                        pb='sm'
                                    >
                                        <Heading
                                            as='h2'
                                            color='black'
                                            variant='h1'
                                        >
                                            {options.heading}
                                        </Heading>
                                    </Box>
                                    {options.subheading ? (
                                        <Box
                                            px='sm'
                                            pb='xxs'
                                            sx={{
                                                borderColor: 'black',
                                                borderStyle: 'solid',
                                                borderWidth: '0',
                                            }}
                                        >
                                            <Heading
                                                as='h3'
                                                variant='h3'
                                                sx={{
                                                    fontSize: '16px',
                                                    fontWeight: '700',
                                                    letterSpacing: '4px',
                                                    textTransform: 'uppercase',
                                                }}
                                            >
                                                {options.subheading}
                                            </Heading>
                                        </Box>
                                    ) : null}
                                </>
                            ) : null}

                            <Box
                                mt={options.showHeadingSection ? '' : 'md'}
                                height='100%'
                                width='100%'
                                sx={{
                                    position: 'relative',
                                }}
                            >
                                <Link to={options.url}>
                                    {badge}
                                    {media.el}
                                </Link>
                            </Box>
                            <Box
                                px='sm'
                                pt={
                                    options.additionalText &&
                                    options.additionalText !== ''
                                        ? 'xl'
                                        : 'sm'
                                }
                                sx={{
                                    position: 'relative',
                                }}
                            >
                                <Heading
                                    as={
                                        options.showHeadingSection &&
                                        firstModule
                                            ? 'h3'
                                            : 'h1'
                                    }
                                    variant='h2'
                                    color={options.titleColor || 'black'}
                                    sx={{
                                        textTransform: 'uppercase',
                                        lineHeight: '32px',
                                    }}
                                >
                                    {options.url && options.url !== '' ? (
                                        <Link
                                            to={options.url}
                                            css={{
                                                color:
                                                    options.titleColor ||
                                                    'black',
                                                textDecoration: 'none',
                                            }}
                                        >
                                            {options.title}
                                        </Link>
                                    ) : (
                                        options.title
                                    )}
                                </Heading>
                                {options.subtitle ? (
                                    <Text
                                        as='p'
                                        variant='paragraph'
                                        fontStyle='italic'
                                        fontSize='md'
                                    >
                                        {options.subtitle}
                                    </Text>
                                ) : null}

                                <NarrativeContent>
                                    <Text
                                        as='p'
                                        variant='paragraph'
                                        fontSize='md'
                                    >
                                        {options.text &&
                                            renderHTML(options.text)}
                                    </Text>
                                </NarrativeContent>

                                {options.additionalText &&
                                options.additionalText !== '' ? (
                                    <Box
                                        sx={{
                                            top: '-90px',
                                            left: 'sm',
                                            pointerEvents: 'none',
                                            position: 'absolute',
                                            zIndex: 1,
                                        }}
                                    >
                                        <Text
                                            variant='bigTextMobile'
                                            sx={{
                                                display: [
                                                    'none',
                                                    'none',
                                                    'none',
                                                    'block',
                                                    'block',
                                                    'block',
                                                    'block',
                                                ],
                                            }}
                                        >
                                            {options.additionalText}
                                        </Text>
                                    </Box>
                                ) : null}
                            </Box>
                        </Box>
                        {options.carousel && carousel.length > 1 ? (
                            <Box
                                mt='sm'
                                sx={{
                                    overflow: 'hidden',
                                }}
                            >
                                <SwiperFilmStrip
                                    onPress={switchImage}
                                    options={{
                                        direction: 'horizontal',
                                        type: 'imageOnly',
                                        disableClick: true,
                                    }}
                                    slides={{ docs: carousel }}
                                />
                            </Box>
                        ) : null}
                        {options.showForSaleButton ? (
                            <Box
                                pt='sm'
                                px='sm'
                                mb='sm'
                            >
                                <Link to='/cars-for-sale/available'>
                                    <Button
                                        width='100%'
                                        variant='primary_aquaDark'
                                    >
                                        All Available
                                    </Button>
                                </Link>
                            </Box>
                        ) : null}
                        {options.showSoldButton ? (
                            <Box
                                pt='sm'
                                px='sm'
                            >
                                <Link to='/cars-for-sale/sold'>
                                    <Button
                                        width='100%'
                                        variant='secondary_aquaDark'
                                    >
                                        Previously Handled
                                    </Button>
                                </Link>
                            </Box>
                        ) : null}
                        {options.showConsignmentButton ? (
                            <Box
                                px='sm'
                                alignSelf='center'
                            >
                                <Link to='/consignment'>
                                    <Button variant='secondary_aquaDark'>
                                        Consign Your Car
                                    </Button>
                                </Link>
                            </Box>
                        ) : null}
                    </Box>
                </Box>
            )
    }

    return content
}

export default FeaturedMobile
